module.exports = __webpack_public_path__ + "img/sui1.0646d82e.png";